module.exports = __webpack_public_path__ + "img/Group952.819054e9.png";